export default __webpack_public_path__ + "static/media/020-facebook.71296914.svg";